import SelectSpecialty from "./pages/SelectSpecialty";
import BookingFlow from "./pages/BookingFlow";
import Ticket from "./pages/Ticket";
import LandingPage from "./pages/LandingPage";
import { DoctorList } from "./pages/DoctorList";
import { TicketSearch } from "./pages/TicketSearch";
import BookingSearch from "./pages/BookingSearch";
import DoctorProfile from "./pages/DoctorProfile";
import NotFoundPage from "./pages/NotFound";

const AppRoutes = [
  { index: true, element: <LandingPage /> },
  { path: "/phong-kham", element: <SelectSpecialty /> },
  { path: "/bac-si", element: <DoctorList /> },
  { path: "/dat-hen", element: <BookingFlow /> },
  { path: "/phieu-kham-benh/:id", element: <Ticket /> }, { path: "/phieu-kham-benh/view", element: <Ticket /> },
  // { path: "/search", element: <BookingSearch /> },
  { path: "/phieu-kham", element: <TicketSearch /> },
  { path: "/profile", element: <DoctorProfile /> },
  // { path: "/test", element: <DoctorCardSkeleton /> },
  // { path: "/testcalendar", element: <TestCalendar /> },

  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default AppRoutes;
